import { inject, Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { Auth } from 'src/providers/auth/auth';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { TidyStorage } from 'src/shared/providers/tidy-storage';

import { EnableAutopilotComponent } from 'src/pages/go-live/enable-autopilot/enable-autopilot.component';

@Injectable({
  providedIn: 'root'
})
export class SubscribeRedirectGuard implements CanActivate {

  private auth = inject(Auth);
  private navCtrl = inject(CustomNavController);
  private rightSidePanelService = inject(RightSidePanelService);
  private storage = inject(TidyStorage);

  async canActivate(): Promise<boolean> {
    if (!this.auth.isAuthenticated()) {
      this.navCtrl.navigateRoot('login');
      return false;
    }
    return true;
  }

  async handleRedirect(): Promise<void> {
    // Clear any leftover onboarding step/action so that after subscribing the
    // dialog simply closes and the user lands back on the Schedule page.
    await this.storage.delete('autopilot-pending-step');
    await this.storage.delete('autopilot-pending-action');

    this.navCtrl.navigateRoot('schedule');

    setTimeout(async () => {
      this.rightSidePanelService.setDialogPageTitle('Subscribe');
      const isRightSidePanelOpen = await this.storage.retrieve('dialog-right-side-open');
      if (isRightSidePanelOpen) {
        this.rightSidePanelService.navigateTo('go-live/enable-autopilot', {}, EnableAutopilotComponent);
      } else {
        await this.storage.save('dialog-right-side-open', true);
        await this.storage.save('dialog-params', {});
        this.rightSidePanelService.openRightSidePanel(EnableAutopilotComponent);
      }
    }, 100);
  }
}
